<template>
  <div class="organization-admin-add-form__wrapper">
    <div class="organization-admin-add-form__header"><h4>Add new user</h4></div>
    <div class="organization-admin-add-form__content">
      <vue-form-generator :schema="schema" :model="formModel" :options="formOptions" @validated="onValidated" />
    </div>
    <button
      type="button"
      class="btn btn-default organization-admin-add-form__submit-button"
      :disabled="hasErrors"
      @click="createUserAndLinkWithHospital"
    >
      <span class="glyphicon glyphicon-plus"></span> Add
    </button>
  </div>
</template>

<script>
import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import methods from './organizationAdminAddForm.methods';
import twiageCheckbox from '../customFields/checkbox/fieldTwiageCheckbox';

Vue.use(VueFormGenerator);
Vue.component('fieldTwiageCheckbox', twiageCheckbox);

export default {
  name: 'OrganizationAdminAddForm',
  data: () => ({
    hasErrors: true,
    formModel: {
      username: '',
      email: '',
      firstName: '',
      lastName: '',
      sendWelcomeEmail: true,
      role: 'members',
    },
    schema: {
      fields: [
        {
          label: 'Username *',
          type: 'input',
          inputType: 'text',
          model: 'username',
          required: true,
          validator: VueFormGenerator.validators.required.locale({
            fieldIsRequired: '',
          }),
        },
        {
          label: 'Email *',
          type: 'input',
          inputType: 'text',
          model: 'email',
          required: true,
          validator: VueFormGenerator.validators.email.locale({
            fieldIsRequired: 'Please enter a valid email address.',
            invalidEmail: 'Please enter a valid email address.',
          }),
        },
        {
          label: 'First Name *',
          type: 'input',
          inputType: 'text',
          model: 'firstName',
          required: true,
          validator: VueFormGenerator.validators.required.locale({
            fieldIsRequired: '',
          }),
        },
        {
          label: 'Last Name *',
          type: 'input',
          inputType: 'text',
          model: 'lastName',
          required: true,
          validator: VueFormGenerator.validators.required.locale({
            fieldIsRequired: '',
          }),
        },
        {
          type: 'twiageCheckbox',
          label: 'Send Welcome E-mail',
          model: 'sendWelcomeEmail',
          default: true,
          disabled: true,
        },
      ],
    },
    formOptions: {
      validateAfterLoad: true,
      validateAfterChanged: true,
    },
  }),
  methods,
};
</script>

<style lang="postcss">
.organization-admin-add-form__content fieldset {
  border: none;
}
</style>

<style lang="postcss" scoped>
.organization-admin-add-form__wrapper {
  max-width: 600px;
  margin: 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizationAdminAddForm/OrganizationAdminAddForm.vue